import { useState } from 'react';
import Checkbox from '../../../../../Core/Fields/Floating/Checkbox';
import PaymentTable from './PaymentTable';

const PaymentDetailsTab = ({ error, fulldata, advancepayment, totalamount, GetAdvancePaymentApi }) => {

    const [allocate_advances_automatically, setallocate_advances_automatically] = useState(false);

    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div className='row px-2' >
                    <div className="col-md-4 px-2">
                        <div className='' style={{ backgroundColor: '#FDF8ED', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Advance Payments</p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <div className='d-flex pb-1 pt-2 align-item-center' style={{ gap: '0px' }}>
                                        <Checkbox id="drt" value={allocate_advances_automatically} onChange={(e)=>{setallocate_advances_automatically(e);}} label="" />
                                        <p className='m-0' style={{ fontSize: '0.8rem', fontWeight: '500', color: '#2C2B31' }}>Allocate Advances Automatically (FIFO)</p>
                                    </div>
                                </div>

                            </div>
                            <div className='pt-2' style={{ display: 'flex', gap: '15px' }}>

                                <div style={{ flex: 1 }} >
                                    <p onClick={() => { GetAdvancePaymentApi()}} className='m-0 pobtn' style={{ cursor: 'pointer', backgroundColor: '#41475A', width: 'fit-content', height: 'fit-content', padding: "7px 16px" }}>Get Advances Received</p>
                                </div>
                            </div>



                        </div>
                    </div>

                    <div className="col-md-8"></div>
                    <div className="col-md-8 px-2 mt-3" >
                        <div style={{ border: '1px solid #DBDBDB', borderRadius: '4px' }}>
                            <div className="px-3 mb-3" style={{ background: '' }}>
                                <div className="row">
                                    <div className="col-12">
                                        <div >
                                            <PaymentTable
                                                rows={advancepayment.advance_Payment_List}
                                                setRows={advancepayment.setadvance_Payment_List}
                                                po_status={""}
                                                error={error}
                                                fulldata={fulldata}
                                                totalamount={totalamount}
                                                allocate_advances_automatically={allocate_advances_automatically}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
};

export default PaymentDetailsTab;